import * as React from "react";
import ActivitiesList from "./ActivitiesList";
import EditActivity from "./EditActivity";
import EventType from "components/Setting/EventType";
import { getActivityType, addActivityType } from "services/activityTypeService";

const ActivityTypes = (props) => {
  return (
    <EventType
      open={props.open}
      close={props.close}
      apiAddFunc={addActivityType}
      buttonLabel="Activity Types"
      listComponent={ActivitiesList}
      editFormComponent={EditActivity}
      component="activityTypes"
    />
  );
};

export default ActivityTypes;
